
<template>
	<div class="panel panel-default">
  		<ly-fixheader :title="title" btn="save"></ly-fixheader>	
		<div class="panel-body">
			<form class="form-horizontal">
				<div class="form-group">
					<label class="col-sm-2 control-label">技师姓名 *</label>
					<div class="col-sm-10">
						<ly-input :value.sync="data.name" title="技师姓名"></ly-input>		
					</div>
				</div>
				<div class="form-group">
					<label class="col-sm-2 control-label">所在门店ID *</label>
					<div class="col-sm-10">
					  	<ly-shopid :value.sync="data.shop_id"></ly-shopid>
					</div>
				</div>
				<div class="form-group">
					<label class="col-sm-2 control-label">技师手机号 *</label>
					<div class="col-sm-10">
					  <ly-input :value.sync="data.mechanic_phone" type="phone" title="技师手机号" maxlength="11"></ly-input>	
					</div>
				</div>
				<div class="form-hr"></div>
					<div class="form-group">
					<label class="col-sm-2 control-label">认证信息</label>
					<div class="col-sm-10">
					    <div class="col-sm-4" style="padding-left:0;">
					    	<select class="form-control" v-model="data.authentication">
					    		<option v-for="el in rzInfo" value="{{el}}">{{el}}</option>
					    	</select>
					    </div>
					</div>
				</div>
				<div class="form-group">
					<label class="col-sm-2 control-label">工种描述</label>
					<div class="col-sm-10">
						<div class="col-sm-4" style="padding-left:0;">
							<select class="form-control" v-model="data.profession">
					    		<option v-for="el in gzInfo" value="{{el}}">{{el}}</option>
					    	</select>
						</div>
					</div>
				</div>
				<div class="form-group">
					<label class="col-sm-2 control-label">简介 *</label>
					<div class="col-sm-10">
					  	<ly-input :value.sync="data.introduction" title="简介(60个字以内)" max="60"></ly-input>	
					</div>
				</div>

				<div class="form-group">
					<label class="col-sm-2 control-label">擅长领域 *</label>
					<div class="col-sm-10">
					  	<ly-input :value.sync="data.good_at" title="擅长领域(30个字以内)" max="30"></ly-input>				      
					</div>
				</div>
				<div class="form-group">
					<label class="col-sm-2 control-label">擅长车型品牌 *</label>
					<div class="col-sm-10">
					  	<ly-input :value.sync="data.good_at_brand" title="擅长品牌(30个字以内)" max="30"></ly-input>	
					</div>
				</div>
				<div class="form-group">
					<label class="col-sm-2 control-label">工作经验 *</label>
					<div class="col-sm-10">
					  	<ly-input :value.sync="data.experience" title="工作经验(整数)" type="nonnegativeInt"></ly-input>				      
					</div>
				</div>
				<div class="form-hr"></div>
				<div class="form-group">
				<label class="col-sm-2 control-label">技师照片，最多2张</label>
				<div class="col-sm-10" style="padding-left:0;">
					<div class="col-sm-6">
						<ly-imgupload v-ref:mechone :image="data.mechanic_img[0]"></ly-imgupload>
					</div>
					<div class="col-sm-6">
						<ly-imgupload v-ref:mechtwo :image="data.mechanic_img[1]"></ly-imgupload>
					</div>
				</div>
				</div>
			</form>
	    </div>
    </div>
</template>
<script>
	var Http = require('../utils/HttpHelper.js');
	var Common = require('../utils/Common.js');
	var isUpdate = false;//标识是[false:新增,true:修改]
	var data = {		
		name : '',//门店显示名称
		shop_id : '',//所属门店ID
		mechanic_phone: '',//技师电话
		authentication : '路易师傅认证技师',//认证信息//路易师傅认证 ,  米其林认证
		profession : '资深技师',//工种描述
		introduction : '',//简介
		good_at : '',//擅长领域
		good_at_brand : '', //擅长汽车品牌
		mechanic_img : [], //技师的照片
		experience: '',//工作经验
	};
	var ver = [
		[
			'mechanic_img',Common.isNoArr,'请选择技师照片'
		]
	];
	/**
	* 返回的处理
	*/
	var goback = function(vm){
		if(isUpdate){
			vm.$dispatch('closeUpdate');
			isUpdate = false;
		}else{
			Common.go('mechanic_list');
		}
	};
	/**
	* 新增
	*/
	var create = function(vm){
		Http['mechanic'].create({
			data : vm.data,
			submitTxt : '保存并提交',
			succ : function(rs){
				Common.tipDialog("提交成功",1500,'success');
				goback(vm);
				Common.go('mechanic_list');
				data = {//新增后清空数据
					name : '',//门店显示名称
					shop_id : '',//所属门店ID
					mechanic_phone: '',//技师电话
					authentication : '路易师傅认证技师',//认证信息//路易师傅认证 ,  米其林认证
					profession : '资深技师',//工种描述
					introduction : '',//简介
					good_at : '',//擅长领域
					good_at_brand : '', //擅长汽车品牌
					mechanic_img : [], //技师的照片
					experience: 0,//工作经验
				};
			},
			err  : function(msg){
				Common.tipDialog(msg,1500,'error');
			}
		});			
	};
	/**
	* 修改
	*/
	var save = function(vm){
		vm.data.status = 1;
		Http['mechanic'].save({
			key : [vm.mid],
			data : vm.data,
			succ : function(rs){
				Common.setProperty(vm.info,vm.data);
				Common.tipDialog("保存成功",1500,'success');
				//分发事件		
				goback(vm);
			},
			err  : function(msg){
				Common.tipDialog(msg,1500,'error');
			}
		});		
	};
	/**
	* 获取技师的照片
	*/
	var getMechImg = function(vm){
		vm.data.mechanic_img = [];
		var one = vm.$refs.mechone.img;
		if(one.length > 0){
			vm.data.mechanic_img.push(one);
		}
		var two = vm.$refs.mechtwo.img;
		if(two.length > 0){
			vm.data.mechanic_img.push(two);
		}
		if(one.length < 0 || two.length <0) {
			Common.tipDialog("请选择技师照片",1500,"error");
			return false;
		}
	};

	module.exports = {
		props : ['info'],//修改时传递过来的数据
		data : function () {
			return {
				submitTxt : '保存并提交',
				data : data,
				isInsert: true,
				title: '新增门店技师信息',
				mid : '',//技师id
				rzInfo : ['路易师傅认证技师','易途中国认证技师','米其林驰加认证技师'],
				gzInfo: ['资深技师','车间主管','客服经理','店长']
			};
		},
		created : function(){
			if(this.info != undefined){//判断是否有数据，没有表示为新增，有表示为修改
				isUpdate = true;
				this.title = '修改门店技师信息';
				this.isInsert = false;
				// Common.setProperty(this.data,this.info);
				this.mid = this.info.id;
				this.$set('data',this.info);
			}
		},
		components : {
			'ly-imgupload' : require('../components/Imgupload.vue'),
			'ly-fixheader' : require('../components/Fixheader.vue'),
			'ly-input' : require('../components/input/text.vue'),
			'ly-shopid' : require('../components/input/ShopID.vue')
		},
		events : {
			submit : function(){
				getMechImg(this);//获取技师的照片
				if(Common.isAdopt(this)){
					Common.tipDialog('保存中,请稍后...',0,'loading');
					if(Common.validate(ver,this.data)){
						var self = this;
						if(isUpdate){
							save(self);
						}else{
							create(self);
						}
					}
				}
			},
			goback : function(){
				goback(this);//这个是上面声明的函数
			}
		}
	}
</script>


/** WEBPACK FOOTER **
 ** mechanic_add.vue?75010f4e
 **/